import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ModalController, Platform } from '@ionic/angular';
import { ProductDetail } from 'src/app/my-products/add-product/add-product.page';
import { LoaderService } from 'src/app/services/loader.service';
import { CategoryResponse } from 'src/app/stores/category.store';
import { SellerProductStore, Variation, Variations } from 'src/app/stores/seller-product.store';

@Component({
  selector: 'app-product-subform',
  templateUrl: './add-product-subform.component.html',
  styleUrls: ['./add-product-subform.component.scss'],
})
export class AddProductSubformComponent implements OnInit {
  readonly ProductDetail = ProductDetail
  @Input() productDetailType: ProductDetail
  @Input() categories: CategoryResponse
  @Input() subCategories: CategoryResponse
  @Input() variations: Variations
  @Input() variationType: number

  @Output() onChange = new EventEmitter<any>();

  @Input() size
  variationForm: FormGroup;
  sizeForm: FormGroup;

  validation_errors: any;

  constructor(
    private modalController: ModalController,
    private FormBuilder: FormBuilder,
    private sellerProductStore: SellerProductStore,
    private loaderService: LoaderService,
    public platform: Platform
  ) { }

  ngOnInit() {
    this.variationForm = this.FormBuilder.group({
      variation_name: new FormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.minLength(2)
        ])
      )
    })
    this.sizeForm = this.FormBuilder.group({
      size_name: new FormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.minLength(2)
        ])
      )
    })
    this.getErrors()
  }

  getErrors() {
    this.validation_errors = {
      variation_name: [
        { type: "required", message: `ADD_PRODUCT_SECTION.PRODUCT_NAME_REQUIRED` },
        { type: "minlength", message: `ADD_PRODUCT_SECTION.VARIATION.VARIATION_SUB_FORM.VARIATION_NAME_LENGTH` }
      ],
      size_name: [
        { type: "required", message: `ADD_PRODUCT_SECTION.PRODUCT_NAME_REQUIRED` },
        { type: "minlength", message: `ADD_PRODUCT_SECTION.VARIATION.VARIATION_SUB_FORM.VARIATION_NAME_LENGTH` }
      ]
    }
  }

  selectCategory(id: number, index: number) {
    const resp = {
      categoryId: id,
      index: index
    }

    if (this.platform.is('mobile')) {
      return this.modalController.dismiss(resp)
    }

    this.onChange.emit(resp);
  }

  selectSubCategory(subCategoryId: number, index: number) {
    const resp = {
      subCategoryId: subCategoryId,
      index: index
    }
    if (this.platform.is('mobile')) {
      return this.modalController.dismiss(resp)
    }

    this.onChange.emit(resp);
  }

  selectCondition(event = null) {
    const resp = {
      condition: true,
      conditionValue: event.detail.value
    }
    if (this.platform.is('mobile')) {
      return this.modalController.dismiss(resp)
    }

    this.onChange.emit(resp);
  }

  setVariationType(event = null) {
    this.modalController.dismiss(event.detail.value, "variant")
  }

  selectSize(event = null) {
    this.modalController.dismiss(event.detail.value, 'size')
  }

  async addVarientType() {
    this.productDetailType = ProductDetail.ADD_VARIENT_TYPE
  }

  async addCustomSize() {
    this.modalController.dismiss("here", 'custom_size')
    // this.productDetailType = ProductDetail.ADD_SIZE_TYPE
  }

  async saveVarient() {
    this.loaderService.showLoading()
    try {
      var resp: any = await this.sellerProductStore.addVariationName(this.variationForm.value)
      this.loaderService.dismissLoading()
      if (resp.status == 1) {
        this.modalController.dismiss(resp.data.id)
      }
    } catch (error) {
      this.loaderService.dismissLoading()
      this.loaderService.presentToast(error.error.data, 'middle', 'danger', 2000)
    }
  }

  saveSize() {
    this.modalController.dismiss(this.sizeForm.value, 'custom_size')
  }

}